import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet } from '@/api/async-util'

const types = {
    GET_ORDER: createAsyncMutation('GET_ORDER'),
    GET_ORDER_CUSTOMER: createAsyncMutation('GET_ORDER_CUSTOMER'),
}

const order = {
    state: {
    },
    mutations: {
    },
    actions: {
        // GET
        getOrderCustomer(store, customerId) {
            let url = api.order + 'Customer/' + customerId
            return doAsyncGet(store, { url, mutationTypes: types.GET_ORDER_CUSTOMER })
        },
        getOrder(store, orderId) {
            let url = api.order + orderId
            return doAsyncGet(store, { url, mutationTypes: types.GET_ORDER })
        },

        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}

export default order
